var _path, _g, _path2, _g2, _path3, _rect, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuybackTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 88,
    viewBox: "0 0 76 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.8511 6H37.9924H12.1336C7.94587 6 7 21 7 21H13.9338H38H62.0662H69C69 21 68.0541 6 63.8511 6Z",
    fill: "#301C6B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_979_6062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0038 6H12C12.698 6 13.304 12.2273 13.795 19.9906C14.2015 26.4541 14.5313 44.3229 14.7538 54.1294C14.8305 57.4238 16.7405 60.4679 19.8318 62.2055L29.9726 67.9254C34.8895 70.6915 41.1105 70.6915 46.0274 67.9254L56.1682 62.2124C59.2595 60.4749 61.1695 57.4307 61.2462 54.1364C61.4687 44.3298 61.7908 26.4541 62.205 19.9975C62.696 12.2273 63.3096 6 64 6H38.0038Z",
    fill: "#302E66"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_979_6062",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 6,
    width: 52,
    height: 64
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0038 6H12C12.698 6 13.304 12.2273 13.795 19.9906C14.2015 26.4542 14.5313 44.3229 14.7538 54.1295C14.8305 57.4238 16.7405 60.468 19.8318 62.2055L29.9726 67.9254C34.8895 70.6916 41.1105 70.6916 46.0274 67.9254L56.1682 62.2124C59.2595 60.4749 61.1695 57.4308 61.2462 54.1364C61.4687 44.3298 61.7908 26.4542 62.205 19.9975C62.696 12.2273 63.3096 6 64 6H38.0038Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_979_6062)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_979_6062)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 19.8329,
    ry: 24.4889,
    transform: "matrix(4.6334e-08 1 1 -4.12372e-08 38.5006 -4.10358)",
    fill: "#944FD8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_979_6062)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 28.9048,
    ry: 35.6905,
    transform: "matrix(4.6334e-08 1 1 -4.12372e-08 38.6406 92.9653)",
    fill: "#3AF0F0"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0288 16.769C23.2568 16.805 23.4638 16.898 23.6498 17.048C23.8418 17.198 23.9918 17.384 24.0998 17.606C24.2138 17.828 24.2708 18.065 24.2708 18.317C24.2708 18.635 24.1898 18.923 24.0278 19.181C23.8658 19.433 23.6288 19.634 23.3168 19.784C23.0108 19.928 22.6478 20 22.2278 20H19.8878V13.727H22.1378C22.5638 13.727 22.9268 13.799 23.2268 13.943C23.5268 14.081 23.7518 14.27 23.9018 14.51C24.0518 14.75 24.1268 15.02 24.1268 15.32C24.1268 15.692 24.0248 16.001 23.8208 16.247C23.6228 16.487 23.3588 16.661 23.0288 16.769ZM20.7068 16.436H22.0838C22.4678 16.436 22.7648 16.346 22.9748 16.166C23.1848 15.986 23.2898 15.737 23.2898 15.419C23.2898 15.101 23.1848 14.852 22.9748 14.672C22.7648 14.492 22.4618 14.402 22.0658 14.402H20.7068V16.436ZM22.1558 19.325C22.5638 19.325 22.8818 19.229 23.1098 19.037C23.3378 18.845 23.4518 18.578 23.4518 18.236C23.4518 17.888 23.3318 17.615 23.0918 17.417C22.8518 17.213 22.5308 17.111 22.1288 17.111H20.7068V19.325H22.1558ZM29.7814 15.068V20H28.9624V19.271C28.8064 19.523 28.5874 19.721 28.3054 19.865C28.0294 20.003 27.7234 20.072 27.3874 20.072C27.0034 20.072 26.6584 19.994 26.3524 19.838C26.0464 19.676 25.8034 19.436 25.6234 19.118C25.4494 18.8 25.3624 18.413 25.3624 17.957V15.068H26.1724V17.849C26.1724 18.335 26.2954 18.71 26.5414 18.974C26.7874 19.232 27.1234 19.361 27.5494 19.361C27.9874 19.361 28.3324 19.226 28.5844 18.956C28.8364 18.686 28.9624 18.293 28.9624 17.777V15.068H29.7814ZM35.4122 15.068L32.4422 22.322H31.5962L32.5682 19.946L30.5792 15.068H31.4882L33.0362 19.064L34.5662 15.068H35.4122ZM37.0545 15.986C37.2225 15.692 37.4685 15.452 37.7925 15.266C38.1165 15.08 38.4855 14.987 38.8995 14.987C39.3435 14.987 39.7425 15.092 40.0965 15.302C40.4505 15.512 40.7295 15.809 40.9335 16.193C41.1375 16.571 41.2395 17.012 41.2395 17.516C41.2395 18.014 41.1375 18.458 40.9335 18.848C40.7295 19.238 40.4475 19.541 40.0875 19.757C39.7335 19.973 39.3375 20.081 38.8995 20.081C38.4735 20.081 38.0985 19.988 37.7745 19.802C37.4565 19.616 37.2165 19.379 37.0545 19.091V20H36.2355V13.34H37.0545V15.986ZM40.4025 17.516C40.4025 17.144 40.3275 16.82 40.1775 16.544C40.0275 16.268 39.8235 16.058 39.5655 15.914C39.3135 15.77 39.0345 15.698 38.7285 15.698C38.4285 15.698 38.1495 15.773 37.8915 15.923C37.6395 16.067 37.4355 16.28 37.2795 16.562C37.1295 16.838 37.0545 17.159 37.0545 17.525C37.0545 17.897 37.1295 18.224 37.2795 18.506C37.4355 18.782 37.6395 18.995 37.8915 19.145C38.1495 19.289 38.4285 19.361 38.7285 19.361C39.0345 19.361 39.3135 19.289 39.5655 19.145C39.8235 18.995 40.0275 18.782 40.1775 18.506C40.3275 18.224 40.4025 17.894 40.4025 17.516ZM42.0115 17.516C42.0115 17.012 42.1135 16.571 42.3175 16.193C42.5215 15.809 42.8005 15.512 43.1545 15.302C43.5145 15.092 43.9135 14.987 44.3515 14.987C44.7835 14.987 45.1585 15.08 45.4765 15.266C45.7945 15.452 46.0315 15.686 46.1875 15.968V15.068H47.0155V20H46.1875V19.082C46.0255 19.37 45.7825 19.61 45.4585 19.802C45.1405 19.988 44.7685 20.081 44.3425 20.081C43.9045 20.081 43.5085 19.973 43.1545 19.757C42.8005 19.541 42.5215 19.238 42.3175 18.848C42.1135 18.458 42.0115 18.014 42.0115 17.516ZM46.1875 17.525C46.1875 17.153 46.1125 16.829 45.9625 16.553C45.8125 16.277 45.6085 16.067 45.3505 15.923C45.0985 15.773 44.8195 15.698 44.5135 15.698C44.2075 15.698 43.9285 15.77 43.6765 15.914C43.4245 16.058 43.2235 16.268 43.0735 16.544C42.9235 16.82 42.8485 17.144 42.8485 17.516C42.8485 17.894 42.9235 18.224 43.0735 18.506C43.2235 18.782 43.4245 18.995 43.6765 19.145C43.9285 19.289 44.2075 19.361 44.5135 19.361C44.8195 19.361 45.0985 19.289 45.3505 19.145C45.6085 18.995 45.8125 18.782 45.9625 18.506C46.1125 18.224 46.1875 17.897 46.1875 17.525ZM48.0935 17.525C48.0935 17.015 48.1955 16.571 48.3995 16.193C48.6035 15.809 48.8855 15.512 49.2455 15.302C49.6115 15.092 50.0285 14.987 50.4965 14.987C51.1025 14.987 51.6005 15.134 51.9905 15.428C52.3865 15.722 52.6475 16.13 52.7735 16.652H51.8915C51.8075 16.352 51.6425 16.115 51.3965 15.941C51.1565 15.767 50.8565 15.68 50.4965 15.68C50.0285 15.68 49.6505 15.842 49.3625 16.166C49.0745 16.484 48.9305 16.937 48.9305 17.525C48.9305 18.119 49.0745 18.578 49.3625 18.902C49.6505 19.226 50.0285 19.388 50.4965 19.388C50.8565 19.388 51.1565 19.304 51.3965 19.136C51.6365 18.968 51.8015 18.728 51.8915 18.416H52.7735C52.6415 18.92 52.3775 19.325 51.9815 19.631C51.5855 19.931 51.0905 20.081 50.4965 20.081C50.0285 20.081 49.6115 19.976 49.2455 19.766C48.8855 19.556 48.6035 19.259 48.3995 18.875C48.1955 18.491 48.0935 18.041 48.0935 17.525ZM56.6203 20L54.6853 17.822V20H53.8663V13.34H54.6853V17.255L56.5843 15.068H57.7273L55.4053 17.525L57.7363 20H56.6203Z",
    fill: "#F7F7FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_979_6062",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 32,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 32,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_979_6062)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6704 49.3017C45.531 49.4411 45.3049 49.4411 45.1655 49.3017L44.1391 48.2753C43.9997 48.1358 43.9997 47.9098 44.1391 47.7704L45.1655 46.744C45.3049 46.6045 45.531 46.6045 45.6704 46.744C45.8098 46.8834 45.8098 47.1094 45.6704 47.2489L45.2534 47.6658L48.5418 47.6658L48.5418 39.2313L39.6165 39.2313C39.4193 39.2313 39.2595 39.0715 39.2595 38.8743C39.2595 38.6772 39.4193 38.5173 39.6165 38.5173L48.8988 38.5173C49.096 38.5173 49.2559 38.6772 49.2559 38.8743L49.2559 48.0228C49.2559 48.22 49.096 48.3798 48.8988 48.3798L45.2534 48.3798L45.6704 48.7968C45.8098 48.9362 45.8098 49.1623 45.6704 49.3017Z",
    fill: "url(#paint0_linear_979_6062)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7056 38.6221C30.845 38.4827 31.071 38.4827 31.2105 38.6221L32.2369 39.6486C32.3763 39.788 32.3763 40.014 32.2369 40.1535L31.2105 41.1799C31.071 41.3193 30.845 41.3193 30.7056 41.1799C30.5662 41.0404 30.5662 40.8144 30.7056 40.675L31.1225 40.258H27.8341V48.6925H36.7595C36.9567 48.6925 37.1165 48.8523 37.1165 49.0495C37.1165 49.2467 36.9567 49.4065 36.7595 49.4065H27.4771C27.28 49.4065 27.1201 49.2467 27.1201 49.0495V39.901C27.1201 39.7038 27.28 39.544 27.4771 39.544H31.1225L30.7056 39.127C30.5662 38.9876 30.5662 38.7616 30.7056 38.6221Z",
    fill: "url(#paint1_linear_979_6062)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1876,
    cy: 43.962,
    r: 6.337,
    fill: "url(#paint2_linear_979_6062)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2585 44.0337L36.8483 45.9668C36.8524 45.9668 36.8524 45.9709 36.8565 45.9709L37.8169 46.685C37.899 46.7466 38.014 46.6891 38.014 46.5865L38.0181 41.2633C38.0098 41.1689 37.9975 41.0703 37.977 40.9759C37.9565 40.8857 37.9278 40.7995 37.8867 40.7256C37.9565 41.2468 37.661 41.8543 37.1603 42.2524C37.0494 42.3427 36.8976 42.4412 36.7293 42.511C36.5487 42.5889 36.0028 42.7777 36.0028 42.7777L34.357 43.3729C34.0738 43.4755 34.0164 43.8531 34.2585 44.0337Z",
    fill: "#F2EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8289 42.4661C36.833 42.462 36.8412 42.462 36.8453 42.4579C36.8535 42.4538 36.8617 42.4497 36.874 42.4415C36.8863 42.4373 36.8945 42.4291 36.9069 42.425C36.911 42.4209 36.9192 42.4168 36.9233 42.4168C36.9356 42.4086 36.952 42.4004 36.9643 42.3922C36.9684 42.3881 36.9725 42.3881 36.9766 42.384C36.9889 42.3758 37.0013 42.3676 37.0177 42.3594C37.0259 42.3553 37.03 42.3512 37.0382 42.3471C37.0464 42.3388 37.0587 42.3347 37.0669 42.3265C37.0792 42.3183 37.0915 42.306 37.108 42.2978C37.1121 42.2978 37.1121 42.2937 37.1162 42.2937C37.1326 42.2814 37.149 42.2691 37.1654 42.2568C37.6662 41.8586 37.9617 41.2512 37.8919 40.73C37.8632 40.6807 37.8262 40.6356 37.7852 40.6027L36.9315 39.9707C36.8494 39.9091 36.7304 39.9666 36.7304 40.0692V41.559C36.7304 42.4948 36.0039 42.778 36.0039 42.778C36.0039 42.778 36.5539 42.5933 36.7304 42.5153C36.7632 42.4989 36.796 42.4825 36.8289 42.4661Z",
    fill: "#DBD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1715 43.8408L39.5816 41.9077C39.5775 41.9077 39.5775 41.9036 39.5734 41.9036L38.613 41.1894C38.5309 41.1278 38.416 41.1853 38.416 41.2879V46.6112C38.4242 46.7056 38.4365 46.8041 38.4571 46.8985C38.4776 46.9888 38.5063 47.075 38.5474 47.1489C38.4776 46.6276 38.7731 46.0202 39.2738 45.6221C39.3846 45.5318 39.5365 45.4333 39.7048 45.3635C39.8813 45.2855 40.4312 45.1008 40.4312 45.1008L42.0771 44.5057C42.3603 44.399 42.4136 44.0214 42.1715 43.8408Z",
    fill: "#F2EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6073 45.4096C39.6032 45.4137 39.595 45.4137 39.5909 45.4178C39.5827 45.4219 39.5745 45.426 39.5622 45.4342C39.5499 45.4383 39.5417 45.4465 39.5294 45.4506C39.5252 45.4547 39.517 45.4588 39.5129 45.4588C39.5006 45.467 39.4842 45.4753 39.4719 45.4835C39.4678 45.4876 39.4637 45.4876 39.4596 45.4917C39.4473 45.4999 39.435 45.5081 39.4185 45.5163C39.4103 45.5204 39.4062 45.5245 39.398 45.5286C39.3898 45.5368 39.3775 45.5409 39.3693 45.5491C39.357 45.5573 39.3447 45.5697 39.3282 45.5779C39.3241 45.5779 39.3241 45.582 39.32 45.582C39.3036 45.5943 39.2872 45.6066 39.2708 45.6189C38.7701 46.017 38.4745 46.6245 38.5443 47.1457C38.573 47.195 38.61 47.2401 38.651 47.2729L39.5006 47.905C39.5827 47.9666 39.7017 47.9091 39.7017 47.8065V46.3166C39.7017 45.385 40.4282 45.0977 40.4282 45.0977C40.4282 45.0977 39.8782 45.2823 39.7017 45.3603C39.673 45.3767 39.6402 45.3932 39.6073 45.4096Z",
    fill: "#DBD9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_979_6062",
    x: 0,
    y: 0,
    width: 76,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_979_6062"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_979_6062",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_979_6062",
    x: -15.9883,
    y: -53.9365,
    width: 108.978,
    height: 99.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_979_6062"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_979_6062",
    x: -17.0498,
    y: 44.0605,
    width: 111.381,
    height: 97.8096,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_979_6062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_979_6062",
    x1: 46.846,
    y1: 45.613,
    x2: 41.8478,
    y2: 39.4545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0603A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8845B",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_979_6062",
    x1: 29.53,
    y1: 42.3109,
    x2: 34.5282,
    y2: 48.4694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0603A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8845B",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_979_6062",
    x1: 38.1876,
    y1: 37.625,
    x2: 38.1876,
    y2: 50.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7770E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#554FD8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuybackTag);
export default __webpack_public_path__ + "static/media/buybackTag.4e6bc134764f436b028d15ef1a746881.svg";
export { ForwardRef as ReactComponent };